<template>
    <div class="t-lk-modal__content t-lk-refuse-lead__container">
        <h2 class="t-lk-modal__title">{{ $root.staticText.lk.leadsReasonTitle }}</h2>
        <div class="t-lk-modal__text">
            {{ $root.staticText.lk.leadsReasonText }}
            <br>
            {{ $root.staticText.lk.leadsReasonText2 }}
        </div>

        <div class="t-lk-refuse-lead t-lk-modal__form">
            <div class="t-form__label t-lk-refuse-lead__label">{{ select.title }}</div>
            <select-custom-cmp
                :data="select"
                ref="selectReason"
            >
            </select-custom-cmp>
        </div>

        <div class="t-lk-refuse-lead__row">
            <div
                class="t-lk-refuse-lead__yes t-btn _lk"
                :class="{_disabled: disabledBtn}"
                @click="refuse"
            >
                {{ $root.staticText.forms.yes }}
            </div>
            <div class="t-lk-refuse-lead__cancel t-btn _lk _border-gray" @click="modalClose">
                {{ $root.staticText.forms.no }}
            </div>
        </div>
    </div>
</template>

<script>
    import selectCustom from '@components/ui-components/select-custom/select-custom-dynamic-input.vue';
    import { mapActions, mapMutations } from "vuex";
    import Vue from "vue";

    export default {
        name: "refuse-lead",
        props: ['props'],
        data() {
            return {
                action: "lk/leads/refuse",
                disabledBtn: false,
                select: {
                    name: 'reason',
                    title: this.$root.staticText.lk.leadsReasonSubtitle,
                    error: false,
                    valid: false,
                    hintField: this.$root.staticText.lk.leadsPlaceholder,
                    value: [],
                    list: this.props.reasons,
                }
            }
        },
        components: {
            'select-custom-cmp': selectCustom,
        },
        methods: {
            ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),
            ...mapMutations('lk', {
                deleteLead: 'deleteLead',
            }),
            ...mapActions('lk', {
                lk_refuseLead: 'leads/refuseLead'
            }),

            async refuse () {
                if (
                    this.select.value.length === 0 &&
                    this.$refs.selectReason.name.length < 10
                ) {
                    this.select.error = true;
                    this.select.valid = false;
                    return;
                }

                this.disabledBtn = true;

                const reqData = {
                    id: this.props.leadId
                }

                if (this.select.value.length) {
                    reqData.reasonId = this.select.value[0].id;
                } else {
                    reqData.comment = this.$refs.selectReason.name;
                }


                const { data, success } = await this.lk_refuseLead(reqData)

                this.disabledBtn = false;

                if (!success) return;

                // прокинул хендлер в пропса
                this.props.refuseHandler?.()
            },
            openError(data) {
                let text = this.$root.staticText.lk.lkErrorText;
                if (data.errors && data.errors.length > 0) {
                    let key = Object.keys(data.errors)[0];
                    if (data.errors[key][0]) {
                        text = data.errors[key][0];
                    }
                }
                this.modalType_lkErrorOpen({
                    title: this.$root.staticText.lk.lkErrorTitle,
                    text: text,
                    closeBthNone: true
                });
            },
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/refuse-lead.vue